import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DropzoneComponent, DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { Certificado } from '../../../pages/facturador/Modelos/Modelos/certificado';
import { Registro, Registrocompania } from '../../../pages/facturador/Modelos/Modelos/registro';
import { LoadingService } from '../../../shared/loading/loading.service';
import { RegistroService } from './registro.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CertificadoService } from 'src/app/pages/facturador/certificado/certificado.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { User } from 'src/app/core/models/auth.models';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})

/**
 * Register-1 component
 */
export class RegisterComponent implements OnInit {
  tipos = [
    { id: 1, name: 'RUC' },
    { id: 2, name: 'Cédula' },
    { id: 3, name: 'Pasaporte' },
    { id: 4, name: 'VENTA A CONSUMIDOR FINAL*' },
    { id: 5, name: 'IDENTIFICACIÓN DELEXTERIOR*' },
];
  // set the currenr year
  year: number = new Date().getFullYear();
  toDate: NgbDate | null
  certificado:File[]
  enviarcertificado:Certificado
  clave:string="";base64Output:string
  files: File[] = [];
  id!: string;currentUser:User;
  registro:Registro
  public type: string = 'component';
  Registrocompania:Registrocompania
  cert:Blob
  private dateToString = (date) => `${date.year}-${date.month}-${date.day}`;
  dropzone: any;
  @ViewChild(DropzoneComponent, { static: false }) componentRef?: DropzoneComponent;
  @ViewChild(DropzoneDirective, { static: false }) directiveRef?: DropzoneDirective;
  constructor(private router: Router,private serviciocertificado :CertificadoService,private route: ActivatedRoute,private calendar: NgbCalendar,private loading :LoadingService,private registroservice: RegistroService) {
    this.enviarcertificado= new Certificado
    this.certificado=[]
    this.id = this.route.snapshot.queryParams['id']!;
    if (this.id == undefined) {
      this.id = this.route.snapshot.paramMap.get('id')!;
    }
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 0)
    this.enviarcertificado= new Certificado
this.registro= new Registro

   }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    this.dropzone = this.componentRef.directiveRef.dropzone();
    this.dropzone.autoDiscover = false
  }
  convertir(date :NgbDate): string{
    return  date.day.toString().padStart(2,"0")+"-"+ date.month+"-" +date.year;
}
public config: DropzoneConfigInterface = {
  url: 'https://httpbin.org/post',
  clickable: true,
  maxFiles: 1,addRemoveLinks: true, maxFilesize: 10, // MB
  acceptedFiles: ".p12", autoReset: null,
  errorReset: null,
  cancelReset: null

};
 async  registrar(){
  this.loading.showloading()
  this.registro.fecha= this.dateToString(this.toDate);
  this.registro.IdPlan=this.id;
   this.registroservice.insertar(this.registro).subscribe({
    next: (res2: any) => {
      this.registroservice.insertarEmpresariol(this.registro).subscribe({
        next: (res: any) => {
          this.enviarcertificado.clave=this.registro.clave
          this.enviarcertificado.fecha=this.convertir(this.toDate)
          this.enviarcertificado.idcompania=res.idCompania
          this.enviarcertificado.ruc=this.registro.ruc
          this.serviciocertificado.subircertificado(this.files[0], this.enviarcertificado).subscribe({
              next: (res: any) => {
                this.loading.presentarOK("Gracias..! le enviamos un mail a su correo "+this.registro.mail  );
                this.router.navigate(['/']);
              },
              error: (error: any) => {
                this.loading.presentarerror(error)
              }
            });
        },
        error: (error: any) => {
          this.loading.presentarerror(error)
        }
      });


  },
  error: (error: any) => {
      this.loading.presentarerror(error)
    }
  });


}
  guardar(){
    this.enviarcertificado.clave=this.clave
    this.enviarcertificado.fecha=this.convertir(this.toDate)
    //  this.enviarcertificado.idcompania=this.currentUser.IdCompania
    //  this.enviarcertificado.ruc=this.currentUser.ruc

  //  this.servicio.subircertificado(this.files[0], this.enviarcertificado).subscribe(data=>{

  //   this.loading.presentarOK("Producto Guardado");
  //   });
  }

  public onUploadInit(args: any): void {
    console.log('onUploadInit:', args);
  }

  public onUploadError(args: any): void {
    console.log('onUploadError:', args);
  }

  public onUploadSuccess(args: any) {
  let accepted = this.dropzone.getAcceptedFiles();
   this.files.push(args[0]);
  }
  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }
}
